import { createAction } from "@reduxjs/toolkit";
import { IDownloadableFile } from "lobbie";

export const setShowFileDownloads = createAction<boolean>("fileDownloads/show");
export const setDownloadableFiles = createAction<IDownloadableFile[]>("fileDownloads/set");
export const addDownloadableFile = createAction<IDownloadableFile>("fileDownloads/add");
export const addDownloadableFiles = createAction<IDownloadableFile[]>("fileDownloads/addFiles");
export const removeDownloadableFiles = createAction<IDownloadableFile[]>("fileDownloads/remove");
